import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { Flow, FlowValidationParameters, FlowValidationResult } from './types'

// actions
export const FETCH_FLOWS = 'flow/FETCH_FLOWS'
export const FETCH_FLOWS_SUCCESS = 'flow/FETCH_FLOWS_SUCCESS'

export const FETCH_FLOW_INFO = 'flow/FETCH_FLOW_INFO'
export const FETCH_FLOW_INFO_SUCCESS = 'flow/FETCH_FLOW_INFO_SUCCESS'

export const START_FLOW_VALIDATION = 'flow/START_FLOW_VALIDATION'
export const UPDATE_FLOW_VALIDATION = 'flow/UPDATE_FLOW_VALIDATION'

export const START_SAVING_FLOW = 'flow/START_SAVING_FLOW'
export const SAVING_FLOW_SUCCESS = 'flow/SAVING_FLOW_SUCCESS'
export const SAVING_FLOW_FAIL = 'flow/SAVING_FLOW_FAIL'

export const UPDATE_NEW_FLOW = 'flow/UPDATE_NEW_FLOW'
export const RESET_NEW_FLOW = 'flow/RESET_NEW_FLOW'

export const FlowActions = {
  fetchFlows: () => createAction(FETCH_FLOWS),
  fetchFlowSuccess: (data: Flow[]) => createAction(FETCH_FLOWS_SUCCESS, data),
  fetchFlowInfo: (entityId: string) => createAction(FETCH_FLOW_INFO, entityId),
  fetchFlowInfoSuccess: (flow: Flow) => createAction(FETCH_FLOW_INFO_SUCCESS, { flow }),
  startFlowValidation: (flow: FlowValidationParameters) => createAction(START_FLOW_VALIDATION, { flow }),
  updateFlowValidation: (result: FlowValidationResult) => createAction(UPDATE_FLOW_VALIDATION, result),
  updateNewFlow: (flow: FlowValidationParameters) => createAction(UPDATE_NEW_FLOW, { flow }),
  resetNewFlow: () => createAction(RESET_NEW_FLOW),
  startSavingFlow: (flow: FlowValidationParameters) => createAction(START_SAVING_FLOW, { flow }),
  savingFlowSuccess: (flow: Flow) => createAction(SAVING_FLOW_SUCCESS, flow)
}

export type FlowActions = ActionsUnion<typeof FlowActions>
